<template>
  <div class="p-10">
    <!-- LOGO MODULE -->
    <div class="mb-10">
      <LogoModule class="text-24" />
    </div>

    <!-- INPUT MODULE -->
    <div class="mb-10">
      <p>Input module</p>
      <InputModule
        placeholder="Your name"
        class="mr-10"
      />
      <InputModule
        v-model="name"
        placeholder="Your name"
        class="mr-10"
      />
      <InputModule
        v-model="name"
        placeholder="Your name"
        :disabled="true"
      />
    </div>

    <!-- BUTTON MODULE -->
    <div class="mb-10">
      <p>Button module</p>
      <ButtonModule
        text="Share"
        prefix="icon-share"
        class="text-app-color"
        :has-hover="true"
      />
      <ButtonModule
        text="Delete"
        prefix="icon-delete"
        class="text-app-color"
      />
    </div>

    <!-- MODAL -->
    <div class="mb-10">
      <p>Modal</p>
      <ButtonModule
        text="Modal"
        class="text-app-color"
        @click="openModal"
      />
    </div>

    <!-- CHECKBOX MODULE -->
    <div class="mb-10">
      <p>Checkbox module</p>
      <checkbox-module
        v-model="checkbox"
        label="Checkbox"
      />
      {{ checkbox }}
    </div>

    <!-- TOGGLE MODULE -->
    <div class="mb-10">
      <p>Toggle module</p>
      <toggle-module
        :value="toggle"
        label="Toggle"
        @input="v => toggle = v"
      />
    </div>

    {{ toggle }}

    <!-- RADIO MODULE -->
    <div>
      <p>Radio module</p>
      <div class="flex">
        <radio-module
          value="1"
          label="One"
          group="test"
          @input="v => radio = v"
        />
        <radio-module
          value="2"
          label="Two"
          group="test"
          :disabled="true"
          @input="v => radio = v"
        />
        <div class="bg-grey-100">
          <radio-module
            value="3"
            label="Three"
            group="test"
            :has-bg="true"
            @input="v => radio = v"
          />
        </div>
      </div>
    </div>

    <!-- DROPDOWN MODULE -->
    <div class="mb-10">
      <p>Dropdown module</p>
      <dropdown-module
        text="Share"
        icon="share"
      >
        <div class="p-22">
          <InputModule
            placeholder="Enter ..."
          />
        </div>
      </dropdown-module>
    </div>

    <!-- PROGRESS BAR MODULE -->
    <div class="mb-10">
      <p>Progress bar module</p>
      <ButtonModule
        text="Upgrade to pro"
        prefix="icon-star"
        class="text-yellow text-16 mb-13 ml-10"
      />
      <progress-bar-module />
    </div>

    <!-- LIST -->
    <div class="mb-10">
      <p>List</p>
      <ul>
        <li>Kayaking with Orca whales</li>
        <li>Capilano suspension bridge</li>
        <li>Moraine Lake</li>
      </ul>
    </div>

    <div class="mb-10">
      <h1>H1</h1>
      <h2>H2</h2>
      <h3>H3</h3>
    </div>

    <!-- MODAL -->
    <modal ref="modal">
      <p v-for="i in 100" :key="i">{{ i }}</p>
    </modal>
  </div>
</template>

<script>
import LogoModule from '@/components/shared/LogoModule'
import InputModule from '@/components/shared/form-controls/InputModule'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import CheckboxModule from '@/components/shared/form-controls/CheckboxModule'
import RadioModule from '@/components/shared/form-controls/RadioModule'
import ToggleModule from '@/components/shared/form-controls/ToggleModule'
import DropdownModule from '@/components/shared/form-controls/DropdownModule'
import Modal from '@/components/shared/Modal'
import ProgressBarModule from '@/components/shared/ProgressBarModule'

export default {
  name: 'UiKitView',

  components: {
    LogoModule,
    InputModule,
    ButtonModule,
    CheckboxModule,
    RadioModule,
    ToggleModule,
    DropdownModule,
    Modal,
    ProgressBarModule
  },

  /* DATA */
  data () {
    return {
      name: 'Bob',
      checkbox: true,
      toggle: true,
      radio: '1'
    }
  },

  /* METHODS */
  methods: {
    openModal () {
      this.$refs.modal.isModalOpen = true
    }
  }
}
</script>
